/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TablesManagementRouteImport } from './routes/tables-management'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PointOfSaleRouteImport } from './routes/point-of-sale'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as OrderHistoryRouteImport } from './routes/order-history'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FirstTimeLoginRouteImport } from './routes/first-time-login'
import { Route as CustomersRouteImport } from './routes/customers'
import { Route as AnalyticsRouteImport } from './routes/analytics'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrderNewIndexRouteImport } from './routes/order/new/index'
import { Route as OrderOrderDetailsOrderIdRouteImport } from './routes/order/order-details/$orderId'
import { Route as OrderOrderDetailsEditOrderIdRouteImport } from './routes/order/order-details/edit/$orderId'

const TablesManagementRoute = TablesManagementRouteImport.update({
  id: '/tables-management',
  path: '/tables-management',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PointOfSaleRoute = PointOfSaleRouteImport.update({
  id: '/point-of-sale',
  path: '/point-of-sale',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderHistoryRoute = OrderHistoryRouteImport.update({
  id: '/order-history',
  path: '/order-history',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuRoute = MenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const FirstTimeLoginRoute = FirstTimeLoginRouteImport.update({
  id: '/first-time-login',
  path: '/first-time-login',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomersRoute = CustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsRoute = AnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderNewIndexRoute = OrderNewIndexRouteImport.update({
  id: '/order/new/',
  path: '/order/new/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderOrderDetailsOrderIdRoute =
  OrderOrderDetailsOrderIdRouteImport.update({
    id: '/order/order-details/$orderId',
    path: '/order/order-details/$orderId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrderOrderDetailsEditOrderIdRoute =
  OrderOrderDetailsEditOrderIdRouteImport.update({
    id: '/order/order-details/edit/$orderId',
    path: '/order/order-details/edit/$orderId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/analytics': typeof AnalyticsRoute
  '/customers': typeof CustomersRoute
  '/first-time-login': typeof FirstTimeLoginRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/menu': typeof MenuRoute
  '/order-history': typeof OrderHistoryRoute
  '/orders': typeof OrdersRoute
  '/point-of-sale': typeof PointOfSaleRoute
  '/settings': typeof SettingsRoute
  '/tables-management': typeof TablesManagementRoute
  '/order/order-details/$orderId': typeof OrderOrderDetailsOrderIdRoute
  '/order/new/': typeof OrderNewIndexRoute
  '/order/order-details/edit/$orderId': typeof OrderOrderDetailsEditOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/analytics': typeof AnalyticsRoute
  '/customers': typeof CustomersRoute
  '/first-time-login': typeof FirstTimeLoginRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/menu': typeof MenuRoute
  '/order-history': typeof OrderHistoryRoute
  '/orders': typeof OrdersRoute
  '/point-of-sale': typeof PointOfSaleRoute
  '/settings': typeof SettingsRoute
  '/tables-management': typeof TablesManagementRoute
  '/order/order-details/$orderId': typeof OrderOrderDetailsOrderIdRoute
  '/order/new': typeof OrderNewIndexRoute
  '/order/order-details/edit/$orderId': typeof OrderOrderDetailsEditOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/analytics': typeof AnalyticsRoute
  '/customers': typeof CustomersRoute
  '/first-time-login': typeof FirstTimeLoginRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/menu': typeof MenuRoute
  '/order-history': typeof OrderHistoryRoute
  '/orders': typeof OrdersRoute
  '/point-of-sale': typeof PointOfSaleRoute
  '/settings': typeof SettingsRoute
  '/tables-management': typeof TablesManagementRoute
  '/order/order-details/$orderId': typeof OrderOrderDetailsOrderIdRoute
  '/order/new/': typeof OrderNewIndexRoute
  '/order/order-details/edit/$orderId': typeof OrderOrderDetailsEditOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/analytics'
    | '/customers'
    | '/first-time-login'
    | '/forgot-password'
    | '/login'
    | '/menu'
    | '/order-history'
    | '/orders'
    | '/point-of-sale'
    | '/settings'
    | '/tables-management'
    | '/order/order-details/$orderId'
    | '/order/new/'
    | '/order/order-details/edit/$orderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/analytics'
    | '/customers'
    | '/first-time-login'
    | '/forgot-password'
    | '/login'
    | '/menu'
    | '/order-history'
    | '/orders'
    | '/point-of-sale'
    | '/settings'
    | '/tables-management'
    | '/order/order-details/$orderId'
    | '/order/new'
    | '/order/order-details/edit/$orderId'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/analytics'
    | '/customers'
    | '/first-time-login'
    | '/forgot-password'
    | '/login'
    | '/menu'
    | '/order-history'
    | '/orders'
    | '/point-of-sale'
    | '/settings'
    | '/tables-management'
    | '/order/order-details/$orderId'
    | '/order/new/'
    | '/order/order-details/edit/$orderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AnalyticsRoute: typeof AnalyticsRoute
  CustomersRoute: typeof CustomersRoute
  FirstTimeLoginRoute: typeof FirstTimeLoginRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MenuRoute: typeof MenuRoute
  OrderHistoryRoute: typeof OrderHistoryRoute
  OrdersRoute: typeof OrdersRoute
  PointOfSaleRoute: typeof PointOfSaleRoute
  SettingsRoute: typeof SettingsRoute
  TablesManagementRoute: typeof TablesManagementRoute
  OrderOrderDetailsOrderIdRoute: typeof OrderOrderDetailsOrderIdRoute
  OrderNewIndexRoute: typeof OrderNewIndexRoute
  OrderOrderDetailsEditOrderIdRoute: typeof OrderOrderDetailsEditOrderIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tables-management': {
      id: '/tables-management'
      path: '/tables-management'
      fullPath: '/tables-management'
      preLoaderRoute: typeof TablesManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/point-of-sale': {
      id: '/point-of-sale'
      path: '/point-of-sale'
      fullPath: '/point-of-sale'
      preLoaderRoute: typeof PointOfSaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order-history': {
      id: '/order-history'
      path: '/order-history'
      fullPath: '/order-history'
      preLoaderRoute: typeof OrderHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu': {
      id: '/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof MenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/first-time-login': {
      id: '/first-time-login'
      path: '/first-time-login'
      fullPath: '/first-time-login'
      preLoaderRoute: typeof FirstTimeLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customers': {
      id: '/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof CustomersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics': {
      id: '/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/new/': {
      id: '/order/new/'
      path: '/order/new'
      fullPath: '/order/new/'
      preLoaderRoute: typeof OrderNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/order-details/$orderId': {
      id: '/order/order-details/$orderId'
      path: '/order/order-details/$orderId'
      fullPath: '/order/order-details/$orderId'
      preLoaderRoute: typeof OrderOrderDetailsOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/order-details/edit/$orderId': {
      id: '/order/order-details/edit/$orderId'
      path: '/order/order-details/edit/$orderId'
      fullPath: '/order/order-details/edit/$orderId'
      preLoaderRoute: typeof OrderOrderDetailsEditOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AnalyticsRoute: AnalyticsRoute,
  CustomersRoute: CustomersRoute,
  FirstTimeLoginRoute: FirstTimeLoginRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MenuRoute: MenuRoute,
  OrderHistoryRoute: OrderHistoryRoute,
  OrdersRoute: OrdersRoute,
  PointOfSaleRoute: PointOfSaleRoute,
  SettingsRoute: SettingsRoute,
  TablesManagementRoute: TablesManagementRoute,
  OrderOrderDetailsOrderIdRoute: OrderOrderDetailsOrderIdRoute,
  OrderNewIndexRoute: OrderNewIndexRoute,
  OrderOrderDetailsEditOrderIdRoute: OrderOrderDetailsEditOrderIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
